import { formatDateMMDDYYYY } from 'helpers/formatHelpers';
import { Prospect } from 'types/prospect';

const getProspectDisplayName = (prospect: Prospect) =>
  `${prospect.customerFirstName || ''} ${
    prospect.customerLastName || ''
  }`.trim();

const getProspectAddress = (prospect: Prospect) =>
  `${prospect.customerStreet || ''} ${prospect.customerCity || ''} ${
    prospect.customerState || ''
  } ${prospect.customerZipCode || ''}`.trim();

const getProspectCreatedDateFormatted = (prospect: Prospect) =>
  formatDateMMDDYYYY(prospect.createdDate) || '-';

const getProspectModifiedDateFormatted = (prospect: Prospect) =>
  formatDateMMDDYYYY(prospect.lastModifiedDate) || '-';

const getProspectLeadStage = (prospect: Prospect) => prospect.leadStage || '-';

const getProspectChannel = (prospect: Prospect) => prospect.channel || '-';

export {
  getProspectAddress,
  getProspectChannel,
  getProspectCreatedDateFormatted,
  getProspectDisplayName,
  getProspectLeadStage,
  getProspectModifiedDateFormatted,
};
